import { useState, useEffect } from 'react';
import { useLang } from '../../i18n/translations';
import { ContactModal } from './ContactModal';

const YEAR = new Date().getFullYear();

export function Footer() {
  const { t } = useLang();
  const [contactOpen, setContactOpen] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('contact') === '1') {
      setContactOpen(true);
      params.delete('contact');
      const newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
      window.history.replaceState(null, '', newUrl);
    }
  }, []);

  return (
    <>
      <footer className="bg-shell border-t border-white/10 mt-4">
        <div className="max-w-[1160px] mx-auto px-5 lg:px-8 py-10">

          <div className="flex flex-col gap-8 lg:flex-row lg:items-start lg:justify-between">

            {/* Colonne 1 — Branding */}
            <div className="flex flex-col gap-3">
              <img
                src="/new_assets/LogoH.svg"
                alt="idaNroh"
                className="h-8 w-auto self-start"
                draggable={false}
              />
              <p className="font-display text-[13px] text-white/55 max-w-[240px] leading-relaxed">
                {t.footer.tagline}. Avant de partir à la gare, sache si tu auras une place.
              </p>
              <p className="font-display text-[12px] text-white/30">
                © {YEAR} idaNroh · Alger, Algérie
              </p>
            </div>

            {/* Colonne 2 — Légal */}
            <div className="flex flex-col gap-2">
              <p className="font-display font-semibold text-[12px] text-white/35 uppercase tracking-widest mb-1">
                Légal
              </p>
              <FooterLink href="/confidentialite/">{t.footer.privacy}</FooterLink>
              <FooterLink href="/conditions/">{t.footer.terms}</FooterLink>
            </div>

            {/* Colonne 3 — Contact */}
            <div className="flex flex-col gap-2">
              <p className="font-display font-semibold text-[12px] text-white/35 uppercase tracking-widest mb-1">
                Contact
              </p>
              <button
                onClick={() => setContactOpen(true)}
                className="text-start font-display text-[13px] text-white/55 hover:text-brand transition-colors"
              >
                Contactez-nous
              </button>
            </div>

          </div>

          {/* Bas */}
          <div className="mt-8 pt-6 border-t border-white/10 flex flex-col lg:flex-row items-center justify-between gap-3">
            <p className="font-display text-[11px] text-white/30 text-center lg:text-start">
              Données fournies par <strong className="font-semibold text-white/50">SOGRAL</strong> via l'API publique Mahatati.
              Prévisions basées sur des tendances statistiques, non contractuelles.
            </p>
            <span className="font-data text-[11px] text-white/20">v0.1.0</span>
          </div>

        </div>
      </footer>

      <ContactModal open={contactOpen} onClose={() => setContactOpen(false)} />
    </>
  );
}

function FooterLink({ href, children }: { href: string; children: React.ReactNode }) {
  return (
    <a
      href={href}
      className="font-display text-[13px] text-white/55 hover:text-brand transition-colors"
    >
      {children}
    </a>
  );
}
